<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I returned this, but haven’t gotten a refund yet</h1>

			<div v-if="!loading && !is_ia_item">
				<p v-if="error_message">{{ error_message }}</p>

				<div v-if="!submitted">
					<h3>Please provide us the return tracking number</h3>
					<v-text-field solo flat label="Tracking number" v-model="tracking_number"></v-text-field>
					<v-btn color="#7DADED" large round dark @click="submit">Submit</v-btn>
				</div>
				<div v-if="missing_return_record">
					<p>
						Unfortunately, it seems you have not started the book return process. Please use <a class="help-link" href="/returns">this link</a> first to initiate our returns process
					</p>
				</div>
			</div>

			<p v-if="!loading && is_ia_item">
				This item is an {{ inclusive_access_name }} item, and cannot be returned. If you drop the course within the add drop period, you will be refunded for it as part of your tuition refund.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import Axios from 'axios';

	export default {
		name: 'NoRefundYet',

		components: {
			BaseNavLinks,
		},

		computed: {
			inclusive_access_name() {
				return this.$globs.institute_info.inclusive_access_name;
			},
		},

		data() {
			return {
				loading: false,
				is_ia_item: false,
				submitted: false,
				tracking_number: null,
				missing_return_record: false,
				error_message: null,
			};
		},

		mounted() {
			this.loading = true;
			Axios.get('/service/customer_help/rest/index.php/customer_help/check_if_ia_item/' +
				parseInt(this.$route.params.id) || 0
			).then(response => {
				if (response.data.status === 'success' && (response = response.data.data)) {
					this.is_ia_item = !!response.is_inclusive_access_item;
				}
			}).finally(() => {
				this.loading = false;
			});
		},

		methods: {
			submit() {
				const self = this;
				self.loading = true;

				Axios.post('/service/customer_help/rest/index.php/customer_help/set_return_tracking_number/', {
					order_line_id: parseInt(self.$route.params.id),
					tracking_number: self.tracking_number,
				})
					.then(function (response) {
						self.submitted = true;
						self.error_message = null;

						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							self.$router.push('/submitted');
						} else {
							if (response['data']['result'] === 'missing_return_record') {
								self.missing_return_record = true;
							}

							if (response['data']['result'] === 'empty_tracking_number') {
								self.submitted = false;
								self.error_message = response['data']['message'];
							}
						}
					})
					.finally(function () {
						self.loading = false;
					});

			},
		},
	}
</script>

<style scoped>

</style>